export const userRole = [
    // { id: "3b54f51f-0443-4686-a7bc-fe21ff38014a", role: "Manager" },
    { id: "6d8f5f3c-8ed1-40d5-b870-d54283c7da28", role: "Broker" },
    { id: "caa18f26-f341-475a-a4fb-86a0a437a44f", role: "Admin" },
];

export const pageTypeList = [
    { add: "add" },
    { list: "list" },
    { edit: "edit" },
    { delete: "delete" },
];

export const stateData = [
    { id: "1", state: "State 1" },
    { id: "2", state: "State 2" },
  ];

export const billTypeList = [
    { id: 1, name: "Abstract" },
    { id: 2, name: "Mineral" },
    { id: 3, name: "Tract" },
    { id: 4, name: "Cursory Title" },
    { id: 5, name: "Due Dilligence" },
    { id: 6, name: "Area Checks" },
    { id: 7, name: "Curative" },
    { id: 8, name: "Other" },
  ];